import {TableContainer, Table, Paper, TableHead, TableBody, TableRow, TableCell, Checkbox} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {TT_SUBSPEC, TT_SPEC, TT_ORDER, TT_FAMILY, TT_GENUS} from './Util.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {getShortSpecName, getCityName} from './Trans.js';
import NotifyDialog from './NotifyDialog.js'
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

const noper_list = [
	{id: 1, oper: '=', allowed: [1,2,3,4,5,6,7,8,9,10,11,12,13,14]},
	{id: 6, oper: '<>', allowed: [1,2,3,4,5,6,7,8,9,10,11,12,13,14]},
	{id: 2, oper: '<', allowed: [10,11,12,13]},
	{id: 3, oper: '>', allowed: [10,11,12,13]},
	{id: 4, oper: '<=', allowed: [10,11,12,13]},
	{id: 5, oper: '>=', allowed: [10,11,12,13]}
];

const NotifyRow = observer((props) => {
	const gStorage = useGlobalStorage();
	const nc = gStorage.notify.nchain[props.ind];

	function nrRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('nrRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'notify') {
			if (msg.op === 'set_activity') {
				if (msg.result === 'OK') {
// 					console.log('nrRxWs: set_activity OK', msg.data);

					gStorage.notify.setTgtActive(props.ind, nc.active ? 0 : 1);
				} else {
					console.error('nrRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('nrRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('nrRxWs: invalid command', msg.cmd);
			return -1;
		}
	}

	function nrToggleActive(e) {
		let _usr = JSON.parse(JSON.stringify(gStorage.conn.user));
		let nc = JSON.parse(JSON.stringify(gStorage.notify.nchain))[props.ind];

		delete _usr.city;
		nc.active = nc.active ? 0 : 1;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'notify',
			op: 'set_activity',
			data: {
				user: _usr,
				notification: nc,
			}
		};

// 		console.log('nrToggleActive', msg);
		gStorage.conn.ws.send(msg, nrRxWs);
		e.stopPropagation();
	}

	function nrEdit() {
		gStorage.notify.setEditTarget(props.ind);
		props.enterEdit();
	}

	return (
		<TableRow key={props.ind}>
			<TableCell onClick={nrEdit} style={{cursor: 'pointer'}} padding='checkbox'>{props.ind + 1}</TableCell>
			<TableCell onClick={nrEdit} style={{cursor: 'pointer'}}>{nc.desc}</TableCell>
			<TableCell padding='none' align='center'>
				<Checkbox
					sx={{minWidth:20, maxWidth:20}}
					size='small'
					indeterminate={false}
					checked={!!nc.active}
					onChange={nrToggleActive}
					disabled={!gStorage.conn.online}
				/>
			</TableCell>
		</TableRow>
	);
});

const Notifications = observer((props) => {
	const [notifyDlgOpen, setNotifyDlgOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function detSpecGetSpecName(tax) {
		return getShortSpecName(tax, gStorage.conn.user);
	}

	function sortTaxons(t1, t2) {
		let n1 = detSpecGetSpecName(t1);
		let n2 = detSpecGetSpecName(t2);

		return n1.localeCompare(n2);
	}

	function detGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function sortCities(p1, p2) {
		let ret = detGetCityName(p1).localeCompare(detGetCityName(p2));
		if (ret)
			return ret;

		return p1.name.localeCompare(p2.name);
	}

	function sortUsers(p1, p2) {
		let ret = p1.last_name.localeCompare(p2.last_name);
		if (ret)
			return ret;

		return p1.first_name.localeCompare(p2.first_name);
	}

	function mkOptionArray() {
		return Array(15).fill().map((_, i) => {
			if (i === 4) {
				const tgt_l = gStorage.lists.assolist.list;
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			} else if (i === 5) {
				const tgt_l = gStorage.lists.citylist.list.slice().sort(sortCities);
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			} else if (i === 6) {
				const tgt_l = gStorage.lists.speclist.list.filter(x => x.t_type === TT_ORDER).sort(sortTaxons);
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			} else if (i === 7) {
				const tgt_l = gStorage.lists.speclist.list.filter(x => x.t_type === TT_FAMILY).sort(sortTaxons);
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			} else if (i === 8) {
				const tgt_l = gStorage.lists.speclist.list.filter(x => x.t_type === TT_GENUS).sort(sortTaxons);
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			} else if (i === 9) {
				const tgt_l = gStorage.lists.speclist.list.filter(x => (x.t_type === TT_SPEC || x.t_type === TT_SUBSPEC) && x.visible === 1).sort(sortTaxons);
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			} else if (i >= 10 && i <= 13) {
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));
				return ({o_list: ol, tgt_list: null});
			} else if (i === 14) {
				const tgt_l = gStorage.lists.userlist.list.filter((user) => user.id !== gStorage.conn.user.id).sort(sortUsers);
				const ol = noper_list.slice().filter(item => item.allowed.includes(i));

				return ({o_list: ol, tgt_list: tgt_l});
			}

			return ({o_list: null, tgt_list: [{id:0, fi: '-'}]});
		});
	}

	useEffect(() => {
		loadNotifications();
		gStorage.notify.setOptionArray(mkOptionArray());
		// eslint-disable-next-line
	}, []);

	const getheader = () => t('notify.notifications');

	function notificationRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('notificationRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'notify') {
			if (msg.op === 'get_nchain') {
				if (msg.result === 'OK') {
// 					console.log('notificationRxWs: get_nchain OK', msg.data);
					gStorage.notify.setNChain(msg.data.n_chain);
				} else {
					console.error('notificationRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('notificationRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('notificationRxWs: invalid command', msg.cmd);
			return -1;
		}
	}

	function loadNotifications() {
		let _usr = JSON.parse(JSON.stringify(gStorage.conn.user));

		delete _usr.city;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'notify',
			op: 'get_nchain',
			data: {
				user: _usr,
			}
		};

// 		console.log('loadNotifications', msg);
		gStorage.conn.ws.send(msg, notificationRxWs);
	}

	function editNotification(ind, e) {
		gStorage.notify.setEditTarget(ind);
		setNotifyDlgOpen(true);
	}

	function addNotification() {
		gStorage.notify.newEditTarget();
		setNotifyDlgOpen(true);
	}

	function notifyDlgClose() {
		setNotifyDlgOpen(false);
		loadNotifications();
	}

// 	console.log('nchain', gStorage.notify.nchain);

	return (
		<div>
			<ObsAppBar getheader={getheader} add_action={addNotification}/>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>#</TableCell>
							<TableCell>{t('common.name')}</TableCell>
							<TableCell padding='none' align='center'>{t('notify.active')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{gStorage.notify.nchain.map((nc, ind) => {
								return <NotifyRow key={ind} ind={ind} enterEdit={editNotification.bind(this, ind)}/>
							})
						}
					</TableBody>
				</Table>
			</TableContainer>

			<NotifyDialog isOpen={notifyDlgOpen} handleClose={notifyDlgClose} />
		</div>
	);
});
	
export default Notifications;
